export class CompletaPagamentoZero {

    idCliente: number;
    shopID: string;
    lang: string;
    cantinaSC: number;
    wineshopSC: number;

    constructor(
        idCliente: number,
        shopID: string,
        lang: string,
        cantinaSC: number,
        wineshopSC: number
    ) {
        this.idCliente = idCliente;
        this.shopID = shopID;
        this.lang = lang;
        this.cantinaSC = cantinaSC;
        this.wineshopSC = wineshopSC;
    }

}